/**
 * CinemaFooter — tri-colour signal bar, white logo, mono "Powered by" line.
 * Shared across all dark public gallery surfaces.
 */
const CinemaFooter = ({ label = 'Powered by Turbo 360 · Turbo IQ', logoSrc = '/turbo-logo-white.png' }) => (
  <footer
    className="flex flex-col items-center gap-[18px]"
    style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: 'clamp(36px,5vw,52px) 24px' }}
  >
    <div className="tiq-signal-bar" style={{ width: 120, height: 4, borderRadius: 2 }} />
    <img src={logoSrc} alt="Turbo 360" className="w-auto" style={{ height: 22, opacity: 0.9 }} />
    <div
      className="tiq-kicker"
      style={{ fontSize: 11, letterSpacing: '0.16em', color: 'rgba(255,255,255,0.4)' }}
    >
      {label}
    </div>
  </footer>
);

export default CinemaFooter;
